const trimName = (file) => {
  let fileName = file.split('.')[0]
  const extension = file.split('.')[1]
  if (fileName.length > 30) {
    fileName = fileName.substring(0, 30) + '...'
  }
  return fileName + '.' + extension
}

const trimNameWithoutExtension = (fileName) => {
  if (fileName.length > 30) {
    return fileName.substring(0, 30) + '....pdf'
  } else {
    return fileName + '.pdf'
  }
}

export {
  trimName,
  trimNameWithoutExtension
}